import React, { useState, useEffect, useRef } from 'react';
import { trackActivity } from '../../services/activity/activity.api.service';
import styles from './track_reading_progress.module.scss';

interface Props {
  articleId?: string;
}

const TrackReadingProgress: React.FC<Props> = ({ articleId }: Props) => {
  const [scrolledWidth, setScrolledWidth] = useState(0);
  const maxScroll = useRef(0);

  const onScrollChange = () => {
    const winScroll = document.documentElement.scrollTop;
    const height = document.getElementById('article-content').scrollHeight;
    let currentScroll = (winScroll / height) * 100;
    currentScroll = currentScroll > 100 ? 100 : currentScroll;
    setScrolledWidth(currentScroll);
  };

  useEffect(() => {
    // When the user scrolls, updates the reading progress value
    window.addEventListener('scroll', onScrollChange, false);

    return () => window.removeEventListener('scroll', onScrollChange, false);
  }, []);

  useEffect(() => {
    // When scrolledWidth changes, updates the max scroll if needed
    if (scrolledWidth > maxScroll.current) {
      maxScroll.current = scrolledWidth;
    }
  }, [scrolledWidth]);

  const trackReadingProgressInDB = () => {
    // An article is considered as read if scroll is 90 or higher
    if (maxScroll.current < 90) {
      return;
    }

    if (!articleId) return;

    trackActivity({
      activity: 'read',
      target_id: articleId,
      target_type: 'Article',
    });
  };

  useEffect(() => {
    // When the user leaves the page
    window.addEventListener('beforeunload', trackReadingProgressInDB, false);

    return () => window.removeEventListener('beforeunload', trackReadingProgressInDB, false);
  }, []);

  return (
    <div
      data-testid='track-reading-progress'
      className={`progress progress-sm w-100 ${styles.customProgressBar}`}
    >
      <div
        className={`progress-bar ${styles.overwrittenDefaultProgressBarColor}`}
        style={{ width: `${scrolledWidth}%` }}
      ></div>
    </div>
  );
};

export default TrackReadingProgress;
